<template>
	<div class="pcnewddetails">
		<el-backtop></el-backtop>
		<div class="">
			<headers @ChangeEmit="ChangeEmit" ref="head"></headers>
		</div>
		<div class="newclassf" v-html="newcontent"></div>
		<footers ref=is_change></footers>
	</div>
</template>

<script>
	import '@/lib-flexible/flexible.js'
	import {session} from '../../storage/storage.js';
	import headers from '../../common/header.vue'
	import footers from '../../common/footers.vue'
	export default{
		data(){
			return{
				newlists:'',
				newlisid:0,
				newtyid:0,
				newcontent:'',
			}
		},
		created() {
			this.aboutnew()
			this.pcnewlist()
			if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
				this.$router.push({path:'./phnewdetail',query:{e:this.$route.query.e}})
			}
		},
		components:{
			headers,
			footers,
		},
		mounted(){
			document.addEventListener('scroll',this.handleScroll,false)
			this.$once('hook:beforeDestroy', () => {
				document.removeEventListener('scroll', this.handleScroll,false)
			})
		},
		methods:{
			handleScroll () {
				let scrollTop = document.documentElement.scrollTop ||document.body.scrollTop 
				this.$refs.head.scrollTop_change(scrollTop)
			},
			pcnewlist(){
				let data={
						type_id:this.newtyid,
						lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
						channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
						mold:'pc',
						page:'1',
						pageSize:'10',
						
					}
				this.$api.get_new_list(data).then((res) => {
						this.newlists=res.data
						console.log('555',this.newlists)
						for(let l=0;l<this.newlists.length;l++){
							if(this.newlists[l].id=this.newlisid){
								console.log('9999',this.newlists[l])
								this.newcontent=this.newlists[l].content
							}
						}
				});
			},
			aboutnew(){
				console.log(this.$route.query.e)
				this.newlisid=this.$route.query.e
				this.newtyid=this.$route.query.typeid
				this.pcnewlist()
			}
		}
	}
</script>

<style>
	body{
		padding: 0;
		margin: 0;
	}
	.pcnewddetails{
		width: 100%;
		height: 100%;
		position: relative;
		background: #fff;
		padding-top:179px;
		box-sizing: border-box;
	}
	.newclassf{
		padding: 0 240px;
		font-size: 18px;
	}
</style>
